export default "__VITE_ASSET__08f15ef5__"